import React from "react";
import { format } from "date-fns";

import { Chip } from "@mui/material";

import BatchDetail from "../../../common/BatchDetail";
import ColumnHeader from "../../../common/ColumnHeader";
import { CLIENTS, getChipColor } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";
import { __getImsiWorkflow } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "status",
  "plan_id",
  "plan",
  "trial_count",
  "zipcode",
  "msisdn",
  "imsi",
  "step",
  "last_updated",
];

const imsiWorkflowColumns = ({ handleColumnClick, client }) => [
  { field: "id", headerName: "ID", flex: 1, sortable: false },
  {
    field: "iccid",
    headerName: "ICCID",
    minWidth: 200,
    flex: 3,
    sortable: false,
    renderHeader: () =>
      client ? (
        <ColumnHeader label="ICCID" handleClick={() => handleColumnClick("iccid")} />
      ) : (
        "ICCID"
      ),
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 120,
    flex: 2,
    sortable: false,
    renderCell: (params) => (
      <Chip label={params.row.status} size="small" color={getChipColor(params.row.status)} />
    ),
  },
  {
    field: "trial_count",
    headerName: "Trials",
    minWidth: 50,
    flex: 1,
    sortable: false,
    renderCell: (params) => <Chip label={`${params.row.trial_count}`} size="small" color="default" />,
  },
  { field: "plan_id", headerName: "Plan ID", flex: 1, sortable: false },
  { field: "plan", headerName: "Plan", minWidth: 250, flex: 4, sortable: false },
  { field: "zipcode", headerName: "Zipcode", minWidth: 75, flex: 1, sortable: false },
  {
    field: "msisdn",
    headerName: "MSISDN",
    minWidth: 100,
    flex: 2,
    sortable: false,
    renderHeader: () =>
      client ? (
        <ColumnHeader label="MSISDN" handleClick={() => handleColumnClick("msisdn")} />
      ) : (
        "MSISDN"
      ),
  },
  {
    field: "imsi",
    headerName: "IMSI",
    minWidth: 100,
    flex: 2,
    sortable: false,
    renderHeader: () =>
      client ? (
        <ColumnHeader label="IMSI" handleClick={() => handleColumnClick("imsi")} />
      ) : (
        "IMSI"
      ),
  },
  { field: "step", headerName: "Step", minWidth: 100, flex: 2, sortable: true },
  {
    field: "created_at",
    headerName: "Created At",
    minWidth: 200,
    filterable: false,
    flex: 3,
    sortable: false,
    valueGetter: (params) => params.row.created_at || null,
    valueFormatter: (params) =>
      params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
    sortComparator: dateSortComparator,
  },
  {
    field: "last_updated",
    headerName: "Last Updated",
    minWidth: 200,
    filterable: false,
    flex: 3,
    sortable: false,
    valueGetter: (params) => params.row.last_updated || null,
    valueFormatter: (params) =>
      params.value && `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
    sortComparator: dateSortComparator,
  },
];

const IMSIWorkflowBatch = () => (
  <BatchDetail
    title="IMSI Workflow"
    apiGet={__getImsiWorkflow}
    client={CLIENTS.ultra}
    columnsFactory={imsiWorkflowColumns}
    copyKeys={COPY_KEYS}
    exportAction="imsi_workflow"
    retryOperation="imsi_workflow"
    showTerminate
    getRowPath={(row) => `/ultra/imsi_workflow/${row.id}`}
  />
);

export default IMSIWorkflowBatch;
